const InitialState = {
}

export const authentication = (state = InitialState , action) =>
{

    switch(action.type)
    {

        default:
                return{
                    ...state
                }
    }

}

export default authentication